export function loadGoogleSdk() {
  return new Promise((resolve, reject) => {
    // If already loaded, resolve immediately
    if (window.google && window.google.accounts) {
      resolve();
      return;
    }

    // Create script tag
    const script = document.createElement("script");
    script.src = "https://accounts.google.com/gsi/client";
    script.async = true;
    script.defer = true;

    script.onload = () => {
      resolve();
    };
    script.onerror = () => reject(new Error("Failed to load Google SDK"));

    document.body.appendChild(script);
  });
}
